import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import Small from 'UIComponents/elements/Small';
import UILink from 'UIComponents/link/UILink';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIMultiColumn from 'UIComponents/layout/UIMultiColumn';
import UIMultiColumnGroup from 'UIComponents/layout/UIMultiColumnGroup';
import UIMultiColumnItem from 'UIComponents/layout/UIMultiColumnItem';
import PortalIdParser from 'PortalIdParser';
import { MARIGOLD_LIGHT, CANDY_APPLE } from 'HubStyleTokens/colors';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup'; // @ts-expect-error dependency missing

import Networks from 'ads-account-connection/lib/Networks';
export const COOKIES_OPTIONS = {
  NONE: 'NONE',
  USING_COOKIE_BANNER: 'USING_COOKIE_BANNER',
  NOT_USING_COOKIE_BANNER: 'NOT_USING_COOKIE_BANNER'
};

const PrivacyLink = () => /*#__PURE__*/_jsx(UILink, {
  external: true,
  href: `/settings/${PortalIdParser.get()}/data-privacy/cookies`,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.privacy.link"
  })
});

const ConsentLink = () => /*#__PURE__*/_jsx(UILink, {
  external: true,
  href: `/settings/${PortalIdParser.get()}/marketing/ads/adAccounts`,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.consent.link"
  })
});

const PrivacyAndConsentSection = ({
  syncDataToggle,
  showCookieBannerError,
  clearCookieBannerError,
  onCookieOptionSelection,
  trackEvent,
  cookiesOptionSelected,
  showErrors
}) => {
  const handleOptionSelection = e => {
    const action = e.target.value === COOKIES_OPTIONS.USING_COOKIE_BANNER ? 'Selected using the cookie banner option' : 'Selected not using the cookie banner option';
    trackEvent('conversionsEventActions', {
      action,
      network: Networks.FACEBOOK,
      isSyncOn: syncDataToggle
    });
    clearCookieBannerError();
    onCookieOptionSelection(e.target.value);
  };

  const showValidationError = showErrors && cookiesOptionSelected === COOKIES_OPTIONS.NONE;

  if (syncDataToggle) {
    return /*#__PURE__*/_jsx(UIFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.privacy.header"
      }),
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(UIMultiColumn, {
          style: {
            border: 0,
            backgroundColor: MARIGOLD_LIGHT
          },
          children: /*#__PURE__*/_jsx(UIMultiColumnGroup, {
            children: /*#__PURE__*/_jsxs(UIMultiColumnItem, {
              titleText: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.privacy.title"
              }),
              children: [/*#__PURE__*/_jsx(Small, {
                use: "help",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.privacy.note"
                })
              }), /*#__PURE__*/_jsx(UIFormControl, {
                error: showValidationError,
                validationMessage: showValidationError ? /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.validationError.privacy",
                  "data-test-id": "privacy-validation-error"
                }) : null,
                children: /*#__PURE__*/_jsxs(UIToggleGroup, {
                  name: "description-example",
                  className: "m-top-2",
                  children: [/*#__PURE__*/_jsx(UIRadioInput, {
                    description: /*#__PURE__*/_jsxs(Small, {
                      use: "help",
                      children: [/*#__PURE__*/_jsx(FormattedMessage, {
                        message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.privacy.option1.description"
                      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(PrivacyLink, {})]
                    }),
                    value: COOKIES_OPTIONS.USING_COOKIE_BANNER,
                    onChange: handleOptionSelection,
                    checked: cookiesOptionSelected === COOKIES_OPTIONS.USING_COOKIE_BANNER,
                    children: /*#__PURE__*/_jsx(Small, {
                      style: {
                        fontWeight: 600
                      },
                      children: /*#__PURE__*/_jsx(FormattedMessage, {
                        message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.privacy.option1.title"
                      })
                    })
                  }), /*#__PURE__*/_jsx(UIRadioInput, {
                    description: /*#__PURE__*/_jsx(Small, {
                      use: "help",
                      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                        message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.privacy.option2.description_jsx",
                        elements: {
                          Link: UILink
                        }
                      })
                    }),
                    value: COOKIES_OPTIONS.NOT_USING_COOKIE_BANNER,
                    onChange: handleOptionSelection,
                    checked: cookiesOptionSelected === COOKIES_OPTIONS.NOT_USING_COOKIE_BANNER,
                    children: /*#__PURE__*/_jsx(Small, {
                      style: {
                        fontWeight: 600
                      },
                      children: /*#__PURE__*/_jsx(FormattedMessage, {
                        message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.privacy.option2.title"
                      })
                    })
                  })]
                })
              })]
            })
          })
        }), showCookieBannerError && /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage // @ts-expect-error prop does not exist
          , {
            style: {
              color: CANDY_APPLE
            },
            message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.privacy.error"
          })
        }), /*#__PURE__*/_jsx(UIMultiColumn, {
          className: "m-top-2",
          children: /*#__PURE__*/_jsx(UIMultiColumnGroup, {
            children: /*#__PURE__*/_jsx(UIMultiColumnItem, {
              titleText: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.consent.title"
              }),
              children: /*#__PURE__*/_jsxs(Small, {
                children: [/*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.consent.description"
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(ConsentLink, {})]
              })
            })
          })
        })]
      })
    });
  }

  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.privacy.header"
    }),
    children: /*#__PURE__*/_jsxs(Small, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.privacy.notify"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(PrivacyLink, {})]
    })
  });
};

PrivacyAndConsentSection.propTypes = {
  syncDataToggle: PropTypes.bool.isRequired
};
export default PrivacyAndConsentSection;